import React, { useEffect, useMemo } from 'react';
import styled from 'styled-components';
import { RectShape } from 'react-placeholder/lib/placeholders';
import "react-placeholder/lib/reactPlaceholder.css";

import { numberToCurrency, device } from 'vqp-common'

import { fetchSimpleInfo } from '../../redux/actions/dashboard'
import { ErrorBox } from '../../components/common'
import { SmallInfoCard } from './'
import useFetch from '../../utils/useFetch'
import { useStore } from '../../providers/store.provider';

const Grid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 15px;
    margin: 15px;

    @media ${device.desktop} {
        grid-template-columns: 1fr 1fr 1fr 1fr;
    }
`

const TAGS = {
    TOTAL: "NumeroPedidos",
    VALUE: "FaturamentoPedidos",
    TICKET: "TicketMedio",
    USERS: "UsuariosUnicos"
}

const icons = {
    [TAGS.TOTAL]: 'dashOrders',
    [TAGS.VALUE]: 'dashCash',
    [TAGS.TICKET]: 'dashCards',
    [TAGS.USERS]: 'dashUsers',
}

export const SmallInfoPanel = ({ filterDates }) => {

    const simpleInfo = useFetch(fetchSimpleInfo, filterDates)

    const drawInfos = () => {
        if (simpleInfo.loading) {
            return (
                <>
                    <RectShape color='#E0E0E0' showLoadingAnimation={true} style={{ width: '100%', height: 300 }} />
                    <RectShape color='#E0E0E0' showLoadingAnimation={true} style={{ width: '100%', height: 300 }} />
                    <RectShape color='#E0E0E0' showLoadingAnimation={true} style={{ width: '100%', height: 300 }} />
                    <RectShape color='#E0E0E0' showLoadingAnimation={true} style={{ width: '100%', height: 300 }} />
                </>
            )
        } else if (simpleInfo.response) {
            return simpleInfo.response.map((info, i) => {
                let value = info.data
                if (info.tag === TAGS.VALUE || info.tag === TAGS.TICKET) {
                    value = numberToCurrency(value)
                }
                return (
                    <SmallInfoCard key={i} title={info.label} value={value} color={i % 2 === 0 ? 'primary' : 'secondary'} icon={icons[info.tag]} />
                )
            })
        } else if (simpleInfo.error) {
            return (
                <ErrorBox message={simpleInfo.error} retry={simpleInfo.refetch} />
            )
        }
        return null
    }

    return (
        <Grid>
            {drawInfos()}
        </Grid>
    )
}